import styled from 'styled-components';

import IconButton from '../IconButton';
import Badge from '../../notification/Badge';

export const StyledIconButton = styled(IconButton)`
  position: relative;
`;

export const StyledBadge = styled(Badge)`
  position: absolute;
  left: 14px;
  top: -11px;
  z-index: 1;
`;
